/* eslint-disable react/no-danger */
import { useTranslator } from 'tradera/lang/translate';
import React from 'react';
import { formatNumberWithSeparators } from 'tradera/utils/format';

export const DetailedSellerRatingsSummary = ({ model }) => {
    const { t } = useTranslator();
    if (model.detailedSellerRatingSummaryForMember) {
        return (
            <table className="profile-page-feedback-summary-table profile-page-feedback-summary-table-as-seller">
                <thead>
                    <tr>
                        <th className="text-left">
                            {t('profileRating_ratingAsSeller')}
                        </th>
                        <th className="text-center">1</th>
                        <th className="text-center">2</th>
                        <th className="text-center">3</th>
                        <th className="text-center">4</th>
                        <th className="text-center">5</th>
                        <th className="text-center">
                            {t('profileRating_averageRating')}
                        </th>
                        <th className="text-center">
                            {t('profileRating_numberOfRatings')}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{t('profileRatingDetailed_itemDescription')}</td>
                        <td className="text-center" colSpan="5">
                            <span className="profile-page-feedback-staple">
                                <span
                                    className={`profile-page-feedback-staple-meter ${model.detailedSellerRatingSummaryForMember.itemDescriptionAverageRatingClass}`}
                                    style={{
                                        width: model
                                            .detailedSellerRatingSummaryForMember
                                            .itemDescriptionAverageRatingInPercent
                                    }}
                                />
                            </span>
                        </td>
                        <td className="text-center">
                            {
                                model.detailedSellerRatingSummaryForMember
                                    .itemDescriptionAverageRating
                            }
                        </td>
                        <td className="text-center">
                            {formatNumberWithSeparators(
                                model.detailedSellerRatingSummaryForMember
                                    .itemDescriptionCategoryCount
                            )}
                        </td>
                    </tr>

                    <tr>
                        <td>{t('profileRatingDetailed_communication')}</td>
                        <td className="text-center" colSpan="5">
                            <span className="profile-page-feedback-staple">
                                <span
                                    className={`profile-page-feedback-staple-meter ${model.detailedSellerRatingSummaryForMember.communicationAverageRatingClass}`}
                                    style={{
                                        width: model
                                            .detailedSellerRatingSummaryForMember
                                            .communicationAverageRatingInPercent
                                    }}
                                />
                            </span>
                        </td>
                        <td className="text-center">
                            {
                                model.detailedSellerRatingSummaryForMember
                                    .communicationAverageRating
                            }
                        </td>
                        <td className="text-center">
                            {formatNumberWithSeparators(
                                model.detailedSellerRatingSummaryForMember
                                    .communicationCategoryCount
                            )}
                        </td>
                    </tr>
                    <tr>
                        <td>{t('profileRatingDetailed_deliveryTime')}</td>
                        <td className="text-center" colSpan="5">
                            <span className="profile-page-feedback-staple">
                                <span
                                    className={`profile-page-feedback-staple-meter ${model.detailedSellerRatingSummaryForMember.deliveryTimeAverageRatingClass}`}
                                    style={{
                                        width: model
                                            .detailedSellerRatingSummaryForMember
                                            .deliveryTimeAverageRatingInPercent
                                    }}
                                />
                            </span>
                        </td>
                        <td className="text-center">
                            {
                                model.detailedSellerRatingSummaryForMember
                                    .deliveryTimeAverageRating
                            }
                        </td>
                        <td className="text-center">
                            {formatNumberWithSeparators(
                                model.detailedSellerRatingSummaryForMember
                                    .deliveryTimeCategoryCount
                            )}
                        </td>
                    </tr>

                    <tr>
                        <td>{t('profileRatingDetailed_shippingCost')}</td>
                        <td className="text-center" colSpan="5">
                            <span className="profile-page-feedback-staple">
                                <span
                                    className={`profile-page-feedback-staple-meter ${model.detailedSellerRatingSummaryForMember.shippingCostAverageRatingClass}`}
                                    style={{
                                        width: model
                                            .detailedSellerRatingSummaryForMember
                                            .shippingCostAverageRatingInPercent
                                    }}
                                />
                            </span>
                        </td>
                        <td className="text-center">
                            {
                                model.detailedSellerRatingSummaryForMember
                                    .shippingCostAverageRating
                            }
                        </td>
                        <td className="text-center">
                            {formatNumberWithSeparators(
                                model.detailedSellerRatingSummaryForMember
                                    .shippingCostCategoryCount
                            )}
                        </td>
                    </tr>
                    <tr className="profile-page-feedback-average-summary">
                        <td colSpan="6">
                            {t('profileRatingDetailed_average')}
                        </td>
                        <td className="text-center">
                            <span>
                                {
                                    model.detailedSellerRatingSummaryForMember
                                        .totalAverageRating
                                }
                            </span>
                        </td>
                        <td className="text-center" />
                    </tr>
                </tbody>
            </table>
        );
    }
    return (
        <div className="profile-page-empty">
            <p
                dangerouslySetInnerHTML={{
                    __html: t('profileRating_empty')
                }}
            />
        </div>
    );
};
